import React, { useEffect, useState } from "react"
import Typography from "aldoo-ra/Typography"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Value from "aldoo-ra/Value"
import { getStoreAccount } from "aldoo-ra/Store/api"
import { usePromise } from "aldoo-ra/usePromise"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import WaveBG from "../../WaveBG"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import { motion } from "framer-motion"

const AccountTypeCard = ({ isExpanded, onToggle }) => {
  const [profile] = Value("user-profile")
  const { result: account, loading, error } = usePromise(getStoreAccount)
  const texts = TextBundle({ id: "aldoo-store" }) || {}

  // useEffect(() => {
  //   if (!account) return
  //   console.log('Account:', account)
  //   console.log('Texts:', texts)
  //   console.log('Account type key:', "account_type_" + account.account_type)
  //   console.log('Attempted lookup:', texts["account_type_" + account.account_type])
  // }, [account, texts])

  return (
    <CMSRender
      contentType="AccountTypeCard"
      renderItem={(card) => {
        return (
          <div className="relative account-card overflow-hidden shadow-custom_card">
            {/* Chevron Toggle - Top Right Corner */}
            <button
              onClick={onToggle}
              className="absolute top-4 right-4 p-1 hover:bg-gray_2/20 rounded-full transition-colors z-20"
            >
              <ChevronDownIcon
                className="w-6 h-6 text-text transition-transform duration-300"
                style={{ transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)" }}
              />
            </button>

            <Typography
              variant="h5"
              className="text-text mt-0 mb-6 relative z-10"
            >
              {card.title}
            </Typography>

            {/* Expandable Content */}
            <motion.div
              initial={{ height: "auto", opacity: 1 }}
              animate={{ height: isExpanded ? "auto" : 0, opacity: isExpanded ? 1 : 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden w-full"
            >
              <div className="relative z-10 pb-10">
                <Typography
                  className="text-primary text-[22px] md:text-[24px] lg:text-[26px] font-bold my-0"
                >
                  {account?.account_type && texts ? (
                    texts["account_type_" + account.account_type] || account.account_type
                  ) : (
                    'Loading...'
                  )}
                </Typography>
              </div>

              <div className="relative left-1/2 transform -translate-x-1/2 w-auto rounded-full flex items-center justify-center z-10 px-5 py-2 bg-theme_white mt-20">
                <Typography
                  variant="info_18_accent"
                  className="text-gray_1 my-0"
                >
                  {texts?.status}
                </Typography>

                <div className="flex items-center ml-2">
                  <Typography
                    variant="info_18"
                    className="text-text my-0"
                  >
                    {account?.state}
                  </Typography>
                </div>
              </div>
            </motion.div>

            {/* Wave Background - only visible when expanded */}
            {isExpanded && (
              <motion.div
                initial={{ y: 280, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 280, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="absolute bottom-0 left-0 right-0 w-full h-[280px] overflow-hidden pointer-events-none"
              >
                <WaveBG
                  waveProps={{
                    frequency: 0.8,
                    amplitude: 35,
                    phase: 220,
                    sampleRate: 28,
                  }}
                  className={"block text-primary_lt"}
                  waveStyle={{
                    width: "110%",
                    height: "280px",
                  }}
                />
              </motion.div>
            )}
          </div>
        )
      }}
    />
  )
}

export default AccountTypeCard
